import { ROUTE_PATH, TEMPLATE_OPTIONS } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaTextAreaModel, SmMetaSelectModel, SmCheckboxModel, SmMetaFileModel, SmDatepickerModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class AssignmentMetaModel extends FormMetaModel {
  constructor() {
    super(
      'Assignments',
      ROUTE_PATH.assignmentGrid,
      ROUTE_PATH.assignmentForm,
      3
    );
  }

  override initProperties(): any {
    const formInfo = super.initProperties();
    const topic = new SmMetaInputModel(
      'topic',
      'topic',
      'input',
      true,
      'col-12 col-md-6',
      1,
      1,
      'Topic',
      'text',
      '',
      false,
      true,
      true,
      false,
      50,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      { evalKey: '', evalParam: [] },
      false,
      [],
      false,
      '',
      null,
      false,
      false,
      false,
      "Topic"
    );

    const description = new SmMetaTextAreaModel(
      'description',
      'description',
      'textarea',
      false,
      'col-12 col-md-6 ',
      1,
      2,
      'Description',
      'textarea',
      '',
      false,
      true,
      true,
      false,
      500,
      1,
      false,
      false,
      { evalKey: '', evalParam: [] },
      'Enter Description...',
    );

    const type_id = new SmMetaSelectModel(
      'type_id',
      'type_id',
      'select',
      true,
      'col-12 col-md-2',
      2,
      3,
      'Type',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'type_name',
      'id'
    );

    const location = new SmMetaSelectModel(
      'location',
      'location',
      'select',
      true,
      'col-12 col-md-2',
      2,
      4,
      'Location',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'city_name',
      'id'
    );

    const category = new SmMetaSelectModel(
      'category',
      'category',
      'select',
      true,
      'col-12 col-md-2',
      2,
      5,
      'Category',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'category_name',
      'id'
    );
    const trainer = new SmMetaSelectModel(
      'trainer',
      'trainer',
      'select',
      true,
      'col-12 col-md-3',
      3,
      7,
      'Trainer',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      null,
      'name',
      'id'
    );
    const emailID = new SmMetaInputModel(
      'emailID',
      'emailID',
      'input',
      true,
      'col-12 col-md-3',
      3,
      8,
      'Email',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      { evalKey: '', evalParam: [] },
      false,
      [],
      false,
      '',
      null,
      false,
      false,
      false,
      "Email"
    );

    const trigger_email = new SmCheckboxModel(
      'trigger_email',
      'trigger_email',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'Trigger Email',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );
    const show_trainer_details = new SmCheckboxModel(
      'show_trainer_details',
      'show_trainer_details',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'Show Trainer Details',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );

    // const upload_document = new SmMetaDynamicFormModel(
    //   'upload_document',
    //   'upload_document',
    //   '',
    //   false,
    //   false,
    //   'Upload Document',
    //   1,
    //   5,
    //   '',
    //   'addlast',
    //   {
    //     upload_documents: new SmMetaFileModel(
    //       'upload_documents',
    //       'upload_documents',
    //       'file',
    //       true,
    //       '',
    //       1,
    //       5,
    //       '',
    //       'singleimagepreview',
    //       '',
    //       false,
    //       true,
    //       true,
    //       false,
    //       0,
    //       0,
    //       false,
    //       ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
    //       3000,
    //       250,
    //       510,
    //       'image',
    //       'profile_pic_path',
    //       false,
    //       false,
    //       2000,
    //       3000
    //     ),
    //   },
    //   5,
    //   true,
    //   true,
    //   true,
    //   true,
    //   [],
    //   32,
    //   true,
    //   { evalKey: 'userType', evalParam: ['CORP_USER'] }
    // );
    const upload_document = new SmMetaFileModel(
      'upload_document',
      'upload_document',
      'file',
      false,
      'col-12 col-lg-6 col-md-6',
      4,
      7,
      '',
      'singleimagepreview',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      ['image/png', 'image/jpeg', 'image/jpg', 'image/webp'],
      3000,
      250,
      510,
      'image',
      'upload_document',
      false,
      false,
      2000,
      3000
    );


    const east = new SmCheckboxModel(
      'east',
      'east',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'East',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );
    const west = new SmCheckboxModel(
      'west',
      'west',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'West',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    ); 
    const north = new SmCheckboxModel(
      'north',
      'north',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'North',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );
    const south = new SmCheckboxModel(
      'south',
      'south',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'South',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );


    const batch_id = new SmMetaSelectModel(
      'batch_id',
      'batch_id',
      'select',
      true,
      'col-12 col-md-2',
      1,
      6,
      'Batch',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'batch_number',
      'id'
    );

    const branch_id = new SmMetaSelectModel(
      'branch_id',
      'branch_id',
      'ng-select',
      false,
      'col-12 col-md-2',
      1,
      5,
      'Branch',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      TEMPLATE_OPTIONS,
      'department_name',
      'id',
      true,
    );
    const group_id = new SmMetaSelectModel(
      'group_id',
      'group_id',
      'ng-select',
      false,
      'col-12 col-md-3',
      1,
      7,
      'Group',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      null,
      'group_name',
      'id',
      true
    );

    const student_ids = new SmMetaSelectModel(
      'student_ids',
      'student_ids',
      'ng-select',
      true,
      'col-12',
      1,
      12,
      'Add Student',
      'select',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      [],
      'name',
      'id',
      true
    );

    // const timeline = new SmMetaDynamicFormModel(
    //     'timeline',
    //     'timeline',
    //     '',
    //     false,
    //     false,
    //     '',
    //     1,
    //     13,
    //     'Timeline',
    //     'addfirst',
    //     {

    //     },
    //     5,
    //     true,
    //     true,
    //     true,
    //     true,
    //     [],
    //     32,
    //     true,
    //     { evalKey: 'userType', evalParam: ['CORP_USER'] }
    // );

    const start_date = new SmDatepickerModel(
      'start_date',
      'start_date',
      'datetimepicker',
      true,
      'col-12 col-md-4 mb-2',
      1,
      1,
      'Start Date and Time',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'd/M/yyyy hh:mm',
      new Date('1970-10-19'),
      new Date('2040-01-01'),
      [],
      false
    );
    const end_date = new SmDatepickerModel(
      'end_date',
      'end_date',
      'datetimepicker',
      true,
      'col-12 col-md-4 mb-2',
      1,
      1,
      'Due Date and Time',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'd/M/yyyy hh:mm',
      new Date('1970-10-19'),
      new Date('2040-01-01'),
      [],
      false
    );
    const noOfStudents = new SmMetaInputModel(
      'noOfStudents',
      'noOfStudents',
      'input',
      false,
      'col-2',
      1,
      3,
      'Number of Students',
      'text',
      '',
      false,
      true,
      true,
      false,
      100,
      1,
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      '',
      { evalKey: '', evalParam: [] },
      false,
      [],
      false,
      '',
      null,
      false,
      false,
      false,
      "Number of student"
    );
    const backDateAssignmentFlag = new SmCheckboxModel(
      'backDateAssignmentFlag',
      'backDateAssignmentFlag',
      'checkbox',
      false,
      'col-3',
      1,
      4,
      'Is back date assignment?',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      true,
      false
    );

    const uploadAssignment = new SmCheckboxModel(
      'uploadAssignment',
      'uploadAssignment',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'Upload Assignment',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      true,
      false,
    );

    // const addDescription = new SmMetaTextAreaModel(
    //   'addDescription',
    //   'addDescription',
    //   'textarea',
    //   false,
    //   'col-12 col-md-6 ',
    //   1,
    //   2,
    //   'Add Description',
    //   'textarea',
    //   '',
    //   false,
    //   true,
    //   true,
    //   false,
    //   100,
    //   1,


    // );

    const addDescription = new SmMetaTextAreaModel(
      'addDescription',
      'addDescription',
      'textarea',
      false,
      'col-12 col-md-6 ',
      1,
      2,
      'Add Description',
      'textarea',
      '',
      false,
      true,
      true,
      false,
      500,
      1,
      false,
      false,
      { evalKey: 'uploadAssignment', evalParam: [false] },
      'Enter Add Description...',
    );

    // const buttons = {
    //   submit: new SmBtnMetaModel('Submit', '', true, false, true, true,false),
    //   isFormControl: false,
    // };
    const travelReimbursementFlag = new SmCheckboxModel(
      'travelReimbursementFlag',
      'travelReimbursementFlag',
      'checkbox',
      false,
      'col-12',
      1,
      4,
      'Travel Reimbursement',
      'checkbox',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      false
    );

    const travelDocUploadStartDate = new SmDatepickerModel(
      'travelDocUploadStartDate',
      'travelDocUploadStartDate',
      'datepicker',
      false,
      'col-12 col-md-4 mb-2',
      1,
      2,
      'Travel Doc Upload Start Date',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'DD/MM/YYYY',
      new Date('1970-10-19'),
      new Date('2040-01-01'),
      [],
      false
    );


    const travelDocUploadEndDate = new SmDatepickerModel(
      'travelDocUploadEndDate',
      'travelDocUploadEndDate',
      'datepicker',
      false,
      'col-12 col-md-4 mb-2',
      1,
      3,
      'Travel Doc Upload End Date',
      'text',
      '',
      false,
      true,
      true,
      false,
      false,
      'DD/MM/YYYY',
      new Date('1970-10-19'),
      new Date('2040-01-01'),
      [],
      false
    );
    const travelEmailDoc = new SmMetaFileModel(
      'travelEmailDoc',
      'travelEmailDoc',
      'file',
      false,
      'input-fg form-group col-6 col-md-6',
      2,
      4,
      'Travel Reimbursement Email Document',
      'singleimagepreview',
      '',
      false,
      true,
      true,
      false,
      0,
      0,
      false,
      ['pdf'],
      2000,
      250,
      510,
      'travelEmailDoc',
      'display_filename',
      false,
      false,
      2000,
      3000
    );

    const regionIds=[]

    const save = new SmBtnMetaModel('Save', '', true, false, true, true, false);



    const readonlyInput = [
      description,
      type_id,
      location,
      category,
      topic,
      trainer,
      emailID,
      trigger_email,
      show_trainer_details,
      batch_id,
      branch_id,
      group_id,
      student_ids,
      start_date,
      end_date,
      noOfStudents,
      backDateAssignmentFlag,
      uploadAssignment,
      addDescription,
      upload_document,
      regionIds
    ];

    const clickable = [
      travelDocUploadStartDate,
      travelDocUploadEndDate
  ]

    return {
      formInfo,
      save,
      // buttons,
      description,
      type_id,
      location,
      category,
      topic,
      trainer,
      emailID,
      trigger_email,
      show_trainer_details,
      batch_id,
      branch_id,
      group_id,
      student_ids,
      // timeline,
      start_date,
      end_date,
      noOfStudents,
      backDateAssignmentFlag,
      uploadAssignment,
      addDescription,
      upload_document,
      readonlyInput,
      travelReimbursementFlag,
      travelDocUploadEndDate,
      travelDocUploadStartDate,
      travelEmailDoc,
      east,
      west,
      north,
      south,
      clickable
    };
  }
}


export class Time {
  id: '';
  internshipCompanyId: '';
  locName: '';
  locAddress: '';
  internRequired: '';
  is_delete: '';
  created: '';
  modified: '';
}

export class assingmentDetailsForm {
  emailID: '';
  topic: '';
  description: '';
  type_id: '';
  location_id: '';
  category_id: '';
  trainer_id: '';
  batch: '';
  branch_id: '';
  group_id: '';
  region_id: '';
  student_id: '';
  upload_assignment_flag: '';
  upload_assignment_description: '';
  travelReimbursementFlag: false;
  travelDocUploadStartDate: '';
  travelDocUploadEndDate: '';
  isEmailSendToTrainer: '';
  isTrainerDetailsShow: '';
  upload_document: '';
  travelEmailDoc: '';
  isgroup:0
}
